'use strict';

var React = require('react'),
    Alert = require('../organisms/Alert'),
    Button = require('../atoms/Button'),
    BtnGroup = require('../molecules/BtnGroup'),
    AlertActionCreators = require('../actions/AlertActionCreators'),
    ZineActionCreators = require('../actions/ZineActionCreators'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    { PropTypes } = React;

var DeleteZineAlert = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    zineSlug: PropTypes.string.isRequired
  },

  render() {
    return (
      <Alert title='Delete Collection?'
             message='Are you sure? Once it’s gone — it’s gone.'>
        <BtnGroup>
          <Button color='red'
                  size='large'
                  onClick={this.handleDeleteClick}>
            Delete
          </Button>
          <Button size='large'
                  onClick={this.handleCancelClick}>
            Cancel
          </Button>
        </BtnGroup>
      </Alert>
    );
  },

  handleDeleteClick() {
    ZineActionCreators.deleteZine(this.props.zineSlug);
  },

  handleCancelClick() {
    AlertActionCreators.hideAlert();
  }
});

module.exports = DeleteZineAlert;



/** WEBPACK FOOTER **
 ** ./alerts/DeleteZineAlert.jsx
 **/